import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { isValidURL } from "../../../util";
import { positions, sizes, widths, textAlignments, icons } from "../../../enums";
import { UploaderMessages } from "./file-utils";
import Button from "../button";
import Icon from "../icon";
import Layout from "../layout";
import TextArea from "../textarea";
import Video from "../video";
/**
 * view for entering video url
 */

var VideoURL = createComponent({
  displayName: 'VideoURL',
  propTypes: {
    videoURL: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onEnter: PropTypes.func.isRequired,
    videoPlaceholderText: PropTypes.string
  },
  defaultProps: {
    videoURL: '',
    videoPlaceholderText: ''
  },
  render: function render(props) {
    var videoURL = props.videoURL,
        onChange = props.onChange,
        onEnter = props.onEnter,
        videoPlaceholderText = props.videoPlaceholderText,
        isValidVideo = isValidURL(videoURL); //video url editor and preview

    return /*#__PURE__*/React.createElement("div", {
      className: "upload-view file-select-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "upload-view__inner"
    }, /*#__PURE__*/React.createElement(Layout, {
      isFluidHeight: true,
      columns: widths.ONE,
      style: {
        margin: 0
      },
      columnStyles: {
        textAlign: textAlignments.CENTER,
        verticalAlign: positions.verticalAlign.MIDDLE
      }
    }, /*#__PURE__*/React.createElement(Layout.Row, {
      columns: widths.TWO
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.TWELVE,
      style: {
        paddingRight: 0
      }
    }, /*#__PURE__*/React.createElement(TextArea, {
      id: "videoUrl",
      value: videoURL,
      onChange: onChange,
      placeholder: videoPlaceholderText
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.FOUR
    }, /*#__PURE__*/React.createElement(Button.Primary, {
      text: UploaderMessages.ACTION_ADD_VIDEO_URL,
      onClick: onEnter
    }))), /*#__PURE__*/React.createElement(Layout.Row, {
      columnStyles: {
        verticalAlign: positions.alignColumns.MIDDLE
      }
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      style: {
        paddingTop: 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "video-player-wrapper"
    }, /*#__PURE__*/React.createElement(Layout, {
      isFluidHeight: true,
      columns: widths.ONE,
      style: {
        margin: 0,
        padding: 0
      },
      rowStyles: {
        margin: 0,
        padding: 0
      },
      columnStyles: {
        textAlign: textAlignments.CENTER,
        verticalAlign: positions.verticalAlign.MIDDLE
      }
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      style: {
        margin: 0,
        padding: 0
      }
    }, isValidVideo ? /*#__PURE__*/React.createElement(Video, {
      src: videoURL,
      width: "480px"
    }) : !isValidVideo ? /*#__PURE__*/React.createElement("div", {
      className: "video-url-invalid"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: icons.VIDEO,
      size: sizes.X3
    })) : null))))))));
  }
});
export default VideoURL;
//# sourceMappingURL=video-url.js.map